import { Controller } from '@hotwired/stimulus'

const SYSTEMS = ['skin', 'heent', 'chest', 'heart', 'abdomen', 'neuro', 'rectal', 'gu']

export default class extends Controller {
  static targets = [
    'systolic', 'diastolic', 'heartRate', 'respiratoryRate', 'temperature',
    'height', 'weight', 'bmi', 'zScore', 'leftVision', 'rightVision'
  ]

  calculateBmi() {
    const height = parseFloat(this.heightTarget.value)
    const weight = parseFloat(this.weightTarget.value)

    if (height > 0 && weight > 0) {
      const heightM = height / 100
      this.bmiTarget.value = (weight / (heightM * heightM)).toFixed(2)
    } else {
      this.bmiTarget.value = ''
    }
  }

  copyFromScreening(event) {
    const d = event.currentTarget.dataset
    const fill = (target, key) => { if (d[key] !== undefined && d[key] !== '') target.value = d[key] }

    fill(this.systolicTarget, 'systolic')
    fill(this.diastolicTarget, 'diastolic')
    fill(this.heartRateTarget, 'heartRate')
    fill(this.respiratoryRateTarget, 'respiratoryRate')
    fill(this.temperatureTarget, 'temperature')
    fill(this.heightTarget, 'height')
    fill(this.weightTarget, 'weight')
    fill(this.bmiTarget, 'bmi')
    fill(this.zScoreTarget, 'zScore')
    fill(this.leftVisionTarget, 'leftVision')
    fill(this.rightVisionTarget, 'rightVision')
  }

  copyRosFromScreening(event) {
    const btn = event.currentTarget
    const miscData = JSON.parse(btn.dataset.rosMisc || '[]')
    const specData = JSON.parse(btn.dataset.rosSpec || '{}')

    // Fill specific rem text areas
    SYSTEMS.forEach(system => {
      const val = specData[system]
      if (val == null || val === '') return
      const ta = this.element.querySelector(`textarea[name*="soap_physical_examination_specific_attributes"][name*="${system}_rem"]`)
      if (ta) ta.value = val
    })

    // Fill miscellaneous nested rows
    if (!miscData.length) return

    const nestedFormEl = this.element.querySelector('[data-controller="nested-form"]')
    if (!nestedFormEl) return

    const container = nestedFormEl.querySelector('[data-nested-form-target="container"]')
    const template = nestedFormEl.querySelector('[data-nested-form-target="template"]')
    if (!container || !template) return

    const visibleRows = () =>
      Array.from(container.querySelectorAll('.nested-fields')).filter(r => r.style.display !== 'none')

    // Add rows until we have enough
    let rows = visibleRows()
    for (let i = rows.length; i < miscData.length; i++) {
      const content = template.innerHTML.replace(/NEW_RECORD/g, `${Date.now()}${i}`)
      container.insertAdjacentHTML('beforeend', content)
      rows = visibleRows()
    }

    // Populate each row
    miscData.forEach((entry, idx) => {
      const row = rows[idx]
      if (!row) return
      SYSTEMS.forEach(system => {
        const val = entry[system]
        if (val == null || val === '') return
        const sel = row.querySelector(`select[name*="${system}_id"]`)
        if (sel) sel.value = val
      })
    })
  }
}
